// @ts-check
import Layout from '~/components/layout';
import React from 'react';

/**
 * @template {{}} [TProps={}] The shape of the props of the component.
 * @typedef {object} ComponentWrapperProps
 * @property {TProps} [componentProps={}]
 * @property {import('~/types/React').ReactFC<TProps>} component
 * @property {boolean} [wrapWithLayout=true]
 */

/**
 * @template {{}} TProps The shape of the component's props.
 * @function
 * @param {ComponentWrapperProps<TProps>} options
 * @returns {import('~/types/React').ReactFC<import('gatsby').PageProps>}
 */
export function getComponentWrapper(options) {
	const { component: Comp, componentProps, wrapWithLayout = true } = options;

	if (Comp === null || Comp === undefined) {
		return null;
	}

	/** @type {ReturnType<typeof getComponentWrapper>} */
	return (gatsbyPageProps) =>
		!wrapWithLayout ? (
			<Comp {...componentProps} {...gatsbyPageProps} />
		) : (
			<Layout className="theme-minimal" {...gatsbyPageProps}>
				<Comp {...componentProps} {...gatsbyPageProps} />
			</Layout>
		);
}
